import React from 'react';
import '../styles/App.css';

import NavBar from './NavBar'
import InputPanel from './InputPanel'
import PredictionsPanel from './PredictionsPanel'

import _ from 'lodash';

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
        inputVars: [],
        predictions: {},
        conditions: [],
        showBounce: false,
        firstTime: {
          'basic_measurements': true,
          'lifestyle': true,
          'biomarkers': true
        }
    }
  }

  loadAppType() {
    fetch(`/api/app_type`, {
      method: 'GET',
      headers: {
          'Content-Type': 'application/json'
      }
    }).then(res => res.json()).then(data => {
      this.setState({
        appType: data
      })
    })
  }
  loadInputVariables() {
    fetch(`/api/input_variables`, {
       method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => res.json()).then(data => {
        // console.log('input vars')
        // console.log(data)
        this.setState({
            inputVars: data
        })
      })
    }

    loadPredictions(){
      // console.log('loading predicitons:')
      // console.log(this.state.inputVars)

      fetch(`/api/predictions`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.state.inputVars)
      }).then(res => res.json()).then(data => {
        // console.log('predictions')
        // console.log(data)
        this.setState({
          'predictions': data
        })
      })
    }

    loadConditions(){
      fetch(`/api/conditions`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
      }).then(res => res.json()).then(data => {
        // console.log('conditions')
        // console.log(data)
        this.setState({
          'conditions': data
        })
      })
    }
    componentDidMount(){
        this.loadAppType()
        this.loadInputVariables()
        this.loadConditions()
    }

    handleInput(inputValue, inputName){
        //update state with value
        //https://stackoverflow.com/questions/29537299/react-how-to-update-state-item1-in-state-using-setstate
        
        //Add user given input value to InputVars. 
        let items = [...this.state.inputVars]
        let idx = _.findIndex(items, function(o){return(o.name === inputName)})
        let item = items[idx]
        item.inputValue = inputValue

        items[idx] = item
        this.setState({
            inputVars: items
        })

        let firstTime = this.state.firstTime

        if (firstTime[item.class]){
          let all_class_items = _.filter(this.state.inputVars, function(o){return(o.class === item.class)})
          
          let all_filled_in = _.every(all_class_items, function(o){return(o.inputValue !== null)})
          
          // if (all_filled_in){

            firstTime[item.class] = false
            this.setState({showBounce: true, firstTime: firstTime})
            // console.log('load first time predictions')
            this.loadPredictions()

          // } 
          // else {
            // this.setState({showBounce: true})
            // console.log('tab not completed yet')
          // }
        } else {
          this.setState({showBounce: false})
          // console.log('load predictions')
          this.loadPredictions()
        }
    }

  render() {
    // 
    return(
      <div style={{width: "100%", minHeight: "100vh"}}>

        {/*<NavBar />*/}

        {/*<div className="container-fluid d-flex flex-column" style={{minHeight: "calc(100vh - 56px)"}}>*/}
        <div className="container-fluid" style={{minHeight: "100vh", width: "100%", maxWidth: "100%", padding: 0}}>

          <div className="row" style={{margin: 0, width: "100%"}}>

          <div className="col-12 col-md-6" style={{padding: 0}}>
            <InputPanel inputVars={this.state.inputVars} handleInput={this.handleInput.bind(this)} />
          </div>

          <div className="col-12 col-md-6 predictions-panel-bg" >
            <PredictionsPanel conditions={this.state.conditions} predictions={this.state.predictions} appType={this.state.appType} showBounce={this.state.showBounce} />
          </div>

          </div>
        </div>
      </div>
    )
  }
}
export default App;
